<template>
  <div class="popup-on-leave">
    <div class="text-right font-weight-bold">
      <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
    </div>
    <div class="popup-on-leave-title pb-3">
      <h2 class="mb-2">ĐĂNG KÍ ĐI HỌC LẠI</h2>
    </div>
    <v-form ref="form" v-if="checkAuthOnLeaveNReverse()">
      <div class="popup-on-leave-day mt-4">
        <div class="class-info">
          <div class="class-info-item">
            <p class="class-info-title">Lớp:</p>
            <p><b class="ml-1">{{ detailStudent.name }}</b></p>
          </div>
          <div class="class-info-item" v-if="reserveData">
            <p class="class-info-title">Lịch bảo lưu:</p>
            <p>Từ <span class="text-red">{{ reserveData.startDate }}</span> đến <span class="text-red">{{ reserveData.endDate }}</span></p>
          </div>
          <div class="class-info-item" v-if="reserveData">
            <p class="class-info-title">Ngày đi học lại:</p>
            <p><span class="text-red">{{ reserveData.learnAgain }}</span></p>
          </div>
        </div>
      </div>
      <div class="popup-on-leave-day mt-4">
        <div style="width: 45%">
          <div class="mt-3 leave-day-item">Ngày đi học lại</div>
          <v-menu
            ref="endDate"
            :close-on-content-click="false"
            :nudge-top="20"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="bodyRequestForm.endDate"
                readonly
                v-bind="attrs"
                v-on="on"
                background-color="white"
                placeholder="-- / -- / ----"
                :rules="endDateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="bodyRequestForm.endDate"
              @input="inputCloseDatePicker('endDate')"
              locale="vi"
            ></v-date-picker>
          </v-menu>
        </div>

        <div style="width: 45%">
          <div class="mt-3 leave-day-item">Lý do</div>
          <v-text-field
            v-model="bodyRequestForm.reason"
            placeholder="Nhập lý do"
            background-color="white"
            :rules="[v => !!v || 'Lý do là bắt buộc']"
          ></v-text-field>
        </div>

      </div>
      <div class="popup-on-leave-confirm pt-3 pb-5 text-center">
        <v-btn
          rounded
          color="#EFF0F7"
          class="text-black btn-reserve mr-3"
          depressed
          @click="closeModal()"
        >
          Bỏ qua
        </v-btn>
        <v-btn
          rounded
          color="#FF6609"
          class="btn-reserve btn-confirm-reserve"
          depressed
          @click="checkValidForm()"
        >
          Xác nhận
        </v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  props: {
    detailStudent: {
      type: Object,
    },
    isPopupLearnAgain: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bodyRequestForm: {
        endDate: null,
        reason: '',
        ticketId: null,
      },
      endDateRules: [
        (v) => !!v || 'Ngày đi học lại không được để trống.',
        () => this.startDateReserve() || 'Ngày đi học lại phải lớn hơn ngày hiện tại',
        () => this.endDateReserve() || 'Ngày đi học lại phải nhỏ hơn ngày kết thúc bảo lưu',
      ],
      numberStudents: 0,
      reserveData: '',
    };
  },

  async created() {
    const data = await this.getCurrentReservation(this.detailStudent.student_product_id);
    this.reserveData = data;
  },

  methods: {
    ...mapActions('student_care', ['getCurrentReservation', 'createLearnAgain']),

    // Chosen Date => Close datePicker
    inputCloseDatePicker(ref) {
      return this.$refs[ref].length ? this.$refs[ref][0].save([]) : this.$refs[ref].save([]);
    },

    // check valid
    async checkValidForm() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        await this.confirmCreateLearnAgain();
      }
    },

    // Tạo mới phiếu học lại
    async confirmCreateLearnAgain() {
      this.bodyRequestForm.ticketId = this.reserveData.id;

      const params = {
        productId: this.detailStudent.student_product_id,
        body: this.bodyRequestForm,
      };

      const res = await this.createLearnAgain(params);
      if (res.success) {
        this.$swal({
          type: 'success',
          title: 'Đăng kí học lại thành công',
          timer: 1500,
        });
        this.$emit('createLearnAgainSuccessfully');
        this.closeModal();
      } else {
        this.$swal({
          type: 'error',
          title: res.message,
          timer: 3000,
        });
      }
    },

    validate() {
      this.$refs.form.validate();
    },

    closeModal() {
      this.$emit('closePopupLearnAgain');
      this.emptyBodyRequestForm();
      this.$refs.form.resetValidation();
    },
    endDateReserve() {
      if (this.bodyRequestForm && this.bodyRequestForm.endDate) {
        let endDate = this.reserveData.endDate.split(',')[1];
        endDate = moment(endDate.trim(), 'DD/MM/YYYY');
        const date = moment(this.bodyRequestForm.endDate);

        return endDate > date;
      }
      return false;
    },

    startDateReserve() {
      if (this.bodyRequestForm && this.bodyRequestForm.endDate) {
        const startDate = moment();
        const date = moment(this.bodyRequestForm.endDate);

        return startDate < date;
      }
      return false;
    },

    emptyBodyRequestForm() {
      this.bodyRequestForm = {
        endDate: null,
        reason: '',
        ticketId: null,
      };
    },
  },

  watch: {
    bodyRequestForm: {
      handler(value) {
        if (value && value.endDate) {
          this.validate();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.popup-on-leave {
  background: #fff;
  padding: 16px;

  .popup-on-leave-title {
    width: 100%;
    text-align: center;

    span {
      color: #bdbdbd;
    }
  }

  .popup-on-leave-confirm {
    background: #f6f6f6;
  }

  .popup-on-leave-day {
    display: flex;
    width: 100%;
    justify-content: space-around;
    background: #f6f6f6;

    .leave-day-item {
      font-weight: 700;
    }
  }

  .text-black {
    color: black !important;
  }
}

.btn-reserve {
  text-transform: none;
  height: 24px !important;
  font-size: 12px;
  font-weight: 600;
  min-width: 95px;
}
.btn-confirm-reserve {
  color: #fff !important;
}
.popup-on-leave-day ::v-deep .v-text-field {
  padding: 0;
}
.popup-on-leave-day ::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: 32px !important;
  border-radius: 4px;
  border-color: #fff;
  padding: 0 10px;
}
::v-deep .v-input__slot::before {
  border-style: none !important;
}
::v-deep .v-icon.v-icon {
  font-size: 16px;
}

::v-deep .v-picker.v-card.v-picker--date.theme--light {
  margin: 0;
}
.class-info {
  width: 100%;
  padding: 15px;
  .class-info-item {
    display: flex;
  }
  .class-info-title {
    width: 30%;
  }
  .text-red {
    color: red;
    background: #ffe4e4;
    padding: 5px 10px;
    border-radius: 5px;
  }
}
</style>
